/**
 * Dark "brand surface" used by the extranet sidebar and the login brand
 * panel (design: dark navy sidebar / left login column).
 *
 * Applied with the design-system `ThemeOverride` around unmodified base
 * components: the base surfaces (`Sidebar`, `Panel`, `Card`) paint with the
 * `secondary` scale (`bg-secondary-100`, `border-secondary-200`, text
 * `secondary-500…800`), so remapping that scale onto the dark end of the
 * `primary` palette turns them into dark surfaces with light text — no
 * bespoke CSS. The values reference the `primary` CSS variables, so a tenant
 * brand theme (`useApplyBrandTheme`, which rewrites `--color-primary-*` on
 * `:root`) re-tints the sidebar too.
 */

import type { ThemeOverrideConfig } from '@components/integrated/theme-override';

export const EXTRANET_DARK_SURFACE_THEME: ThemeOverrideConfig = {
  id: 'extranet-dark-surface',
  colors: {
    secondary: {
      50: 'var(--color-primary-950, #0b1a2c)',
      100: 'var(--color-primary-900)',
      200: 'var(--color-primary-800)',
      300: 'var(--color-primary-700)',
      400: 'var(--color-primary-300)',
      500: 'var(--color-primary-200)',
      600: 'var(--color-primary-100)',
      700: 'var(--color-primary-50)',
      800: '#ffffff',
      900: '#ffffff',
      950: '#ffffff',
    },
  },
};
